import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Quais cidades a Brasil Transportes atende?",
    a: "Atendemos Belém, Ananindeua, Marituba, Benevides, Barcarena, Abaetetuba, Castanhal, Santa Izabel, Vigia e toda a Região Metropolitana de Belém. Outras localidades do Pará são atendidas mediante consulta.",
  },
  {
    q: "Quais tipos de veículos vocês transportam?",
    a: "Atendemos carros e veículos leves, utilitários e motocicletas, com reboque Asa Delta e plataforma, conforme o tipo de veículo e a situação.",
  },
  {
    q: "Qual a diferença entre reboque Asa Delta e plataforma?",
    a: "O reboque Asa Delta remove o veículo apoiado sobre o equipamento, ideal para remoções rápidas de veículos leves. A plataforma transporta o veículo integralmente sobre a carroceria, indicada quando o veículo não pode rodar ou precisa de transporte totalmente apoiado.",
  },
  {
    q: "Como solicito um guincho em Belém?",
    a: "Você pode chamar direto no WhatsApp (91) 98174-0728 ou ligar para o mesmo número. Informe sua localização e o veículo para agilizar o atendimento.",
  },
  {
    q: "Vocês fazem recarga de bateria e troca de pneu?",
    a: "Sim. Além do reboque, oferecemos assistência veicular com recarga de bateria e troca de pneu em situações de emergência.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-[#0A0A0A]">
      <div className="max-w-4xl mx-auto px-4 py-16 md:py-24">
        <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Dúvidas</p>
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
          Perguntas frequentes
        </h2>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left text-base md:text-lg font-semibold text-white hover:text-[#FEFB0E] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 text-sm md:text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
